import React, { useState, useEffect } from 'react';
import Heading from '../../components/Heading/Heading';
import NavBar from '../../components/NavBar/NavBar';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-data-table-component-extensions/dist/index.css';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import { walletTransactionList } from '../../api/apiHandler';
import dayjs from 'dayjs';

const WalletControl = ({ isLoader }) => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);

  const [selectedType, setSelectedType] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const donor_data = JSON.parse(localStorage.getItem('DAData'));
  const wallet_id = donor_data?.wallet_id;

  const typeOptions = [
    { value: "credit_add", label: "Credit" },
    { value: "credit_use", label: "Debit" },
  ];

  const formatLabel = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/_/g, " ") 
    .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  
  useEffect(() => {
    isLoader(true);
    TransactionList();
    isLoader(false);
  }, [isLoader]);

  const TransactionList = async () => {
    try {
      const res = await walletTransactionList({ wallet_id: wallet_id });
      if (res?.data?.code === "1" || res?.data?.code === 1){
        setTransactions(res.data.data.transaction_list || []);
        setFilteredTransactions(res.data.data.transaction_list || []);
      } else {
        setTransactions([]);
        setFilteredTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching wallet transactions:", error);
    }
  };

  // Filter by type and date range
  useEffect(() => {
    if (!startDate && !endDate && !selectedType) {
      setFilteredTransactions(transactions);
      return;
    }

    setFilteredTransactions(
      transactions.filter((item) => {
        const txDate = new Date(item.created_at);
        const isInDateRange =
          !startDate || !endDate || (txDate >= startDate && txDate <= endDate);
        const typeMatch =
          !selectedType || item.txn_type?.toLowerCase() === selectedType.value;
        return isInDateRange && typeMatch;
      })
    );
  }, [startDate, endDate, selectedType, transactions]);

  const handleAddWallet = () => {
    navigate('/add-to-wallet');
  };
  const handleTransferToSchoolWallet = () => {
    navigate('/transfer-to-school-wallet');
  };


  const columns = [
    {
      name: "Date",
      selector: (row) => dayjs(row.created_at).format("YYYY-MM-DD"),
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => (row.txn_type === "credit_use" ? "Debited" : "Credited" ),
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => `$${parseFloat(row.amount).toFixed(2)}`,
      sortable: true,
    },
    {
      name: "Source",
      selector: (row) => row.source_type,
      sortable: true,
    },
    {
      name: "Notes",
      selector: (row) => formatLabel(row.notes) || "-",
      sortable: false,
      grow: 2,
    },
  ];

  return (
    <>
      <NavBar />
      <section className="content home">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mt-5 pt-3 mb-2">
            <h3>Transaction Lists</h3>
            <div >
            <button
                className="btn btn-primary btn-round"
                onClick={handleTransferToSchoolWallet}
              >
                Transfer To School Wallet
            </button>
            <button
                className="btn btn-primary btn-round ml-3"
                onClick={handleAddWallet}
              >
                Add to Wallet
            </button>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12">

          <div className="card">
            <div className="body">
              {/* --- Filters --- */}
              <div className="row mb-3">
                <div className="col-md-3">
                  <Select
                    options={typeOptions}
                    placeholder="Select Type"
                    onChange={(e) => setSelectedType(e)}
                    value={selectedType}
                    isClearable
                  />
                </div>
                <div className="col-md-3">
                   <div className="form-group mt-0 mb-0">
                  <div  className='form-line'>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    placeholderText="Select Date"
                    className="form-control"
                    isClearable={true}
                  />
                  </div>
                  </div>
                </div>
              </div>

              {/* --- DataTable --- */}
              <DataTable
                columns={columns}
                data={filteredTransactions}
                pagination
                highlightOnHover
                responsive
                persistTableHead
              />
            </div>
          </div>
        </div>
        </div>
      </div>
      </section>
    </>
  );
};

export default WalletControl;
